export default function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-zinc-950 text-white relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-yellow-400 via-yellow-300 to-yellow-400"></div>
      
      <div className="max-w-7xl mx-auto px-8 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Logo & Açıklama */}
          <div className="md:col-span-1">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-14 h-14 bg-yellow-400 rounded-xl flex items-center justify-center">
                <i className="ri-taxi-line text-black text-3xl"></i>
              </div>
              <div>
                <h3 className="text-2xl font-black text-white whitespace-nowrap">BAŞHARIK</h3>
                <p className="text-yellow-400 text-sm font-black whitespace-nowrap">TAKSİ</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Şehir içi ve şehirler arası güvenli, konforlu taksi hizmeti. Kredi kartı geçerlidir.
            </p>
            <div className="flex space-x-3">
              <a href="https://instagram.com/44t0702" target="_blank" rel="nofollow noreferrer" className="w-10 h-10 bg-yellow-400 hover:bg-yellow-300 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-black text-lg"></i>
              </a>
              <a href="https://wa.me/905302064644" target="_blank" rel="nofollow noreferrer" className="w-10 h-10 bg-yellow-400 hover:bg-yellow-300 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-whatsapp-line text-black text-lg"></i>
              </a>
            </div>
          </div>

          {/* Hızlı Linkler */}
          <div>
            <h4 className="text-lg font-black text-white mb-6 relative inline-block whitespace-nowrap">
              Hızlı Linkler
              <div className="absolute -bottom-2 left-0 w-12 h-1 bg-yellow-400"></div>
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="#hakkimizda" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm cursor-pointer whitespace-nowrap flex items-center space-x-2">
                  <i className="ri-arrow-right-s-line"></i>
                  <span>Hakkımızda</span>
                </a>
              </li>
              <li>
                <a href="#hizmetler" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm cursor-pointer whitespace-nowrap flex items-center space-x-2">
                  <i className="ri-arrow-right-s-line"></i>
                  <span>Hizmetlerimiz</span>
                </a>
              </li>
              <li>
                <a href="#yorumlar" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm cursor-pointer whitespace-nowrap flex items-center space-x-2">
                  <i className="ri-arrow-right-s-line"></i>
                  <span>Yorumlar</span>
                </a>
              </li>
              <li>
                <a href="#iletisim" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm cursor-pointer whitespace-nowrap flex items-center space-x-2">
                  <i className="ri-arrow-right-s-line"></i>
                  <span>İletişim</span>
                </a>
              </li>
            </ul>
          </div>

          {/* İletişim */}
          <div>
            <h4 className="text-lg font-black text-white mb-6 relative inline-block whitespace-nowrap">
              İletişim
              <div className="absolute -bottom-2 left-0 w-12 h-1 bg-yellow-400"></div>
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <i className="ri-phone-fill text-yellow-400 text-lg mt-1"></i>
                <div>
                  <p className="text-gray-400 text-xs mb-1 whitespace-nowrap">Telefon 1</p>
                  <a href="tel:05308920944" className="text-white font-black text-sm hover:text-yellow-400 transition-colors cursor-pointer whitespace-nowrap">
                    0530 892 09 44
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-phone-fill text-yellow-400 text-lg mt-1"></i>
                <div>
                  <p className="text-gray-400 text-xs mb-1 whitespace-nowrap">Telefon 2</p>
                  <a href="tel:05302064644" className="text-white font-black text-sm hover:text-yellow-400 transition-colors cursor-pointer whitespace-nowrap">
                    0530 206 46 44
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-instagram-fill text-yellow-400 text-lg mt-1"></i>
                <div>
                  <p className="text-gray-400 text-xs mb-1 whitespace-nowrap">Instagram</p>
                  <a href="https://instagram.com/44t0702" target="_blank" rel="nofollow noreferrer" className="text-white font-black text-sm hover:text-yellow-400 transition-colors cursor-pointer whitespace-nowrap">
                    @44t0702
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-bank-card-fill text-yellow-400 text-lg mt-1"></i>
                <div>
                  <p className="text-gray-400 text-xs mb-1 whitespace-nowrap">Ödeme</p>
                  <p className="text-white text-sm font-semibold whitespace-nowrap">Kredi Kartı Geçerlidir</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Çalışma Saatleri */}
          <div>
            <h4 className="text-lg font-black text-white mb-6 relative inline-block whitespace-nowrap">
              Çalışma Saatleri
              <div className="absolute -bottom-2 left-0 w-12 h-1 bg-yellow-400"></div>
            </h4>
            <div className="space-y-4">
              <div className="bg-zinc-900 rounded-xl p-4 border-l-4 border-yellow-400">
                <div className="flex items-center space-x-3 mb-2">
                  <i className="ri-time-line text-yellow-400 text-xl"></i>
                  <p className="text-white font-black text-sm whitespace-nowrap">7/24 Hizmet</p>
                </div>
                <p className="text-gray-400 text-xs">
                  Her gün, her saat hizmetinizdeyiz
                </p>
              </div>
              <div className="bg-zinc-900 rounded-xl p-4">
                <div className="flex items-center space-x-3">
                  <i className="ri-whatsapp-line text-green-400 text-xl"></i>
                  <div>
                    <p className="text-white font-black text-sm whitespace-nowrap">WhatsApp Destek</p>
                    <p className="text-gray-400 text-xs whitespace-nowrap">Anında yanıt</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Alt Çizgi */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm whitespace-nowrap">
              © {currentYear} Başharık Taksi. Tüm hakları saklıdır.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-gray-500 hover:text-yellow-400 text-sm transition-colors cursor-pointer whitespace-nowrap">
                Gizlilik Politikası
              </a>
              <a href="#" className="text-gray-500 hover:text-yellow-400 text-sm transition-colors cursor-pointer whitespace-nowrap">
                Kullanım Koşulları
              </a>
            </div>
          </div>
          
          {/* Epiked */}
          <a href="https://epiked.com" target="_blank" rel="nofollow noreferrer" className="flex items-center justify-center space-x-3 mt-8 pt-8 border-t border-white/10 hover:opacity-80 transition-opacity cursor-pointer">
            <img src="/logo.avif" alt="Epiked" className="h-6 w-auto" />
            <p className="text-gray-500 text-sm">
              Profesyonel web sistemleri ile hazırlanmıştır.
            </p>
          </a>
        </div>
      </div>
    </footer>
  );
}
